/** Адрес в тексте; хвостовую пунктуацию предложения в ссылку не берём. */
const URL_PATTERN = /https?:\/\/[^\s<>"']*[^\s<>"'.,;:!?)»]/g

/**
 * Делает кликабельными голые адреса в тексте уведомления и открывает все
 * внешние ссылки в новой вкладке. Работает по уже обеззараженному HTML.
 * Та же логика, что в кабинете igra (vpn-igra, modules/notifications).
 */
export function linkifyHtml(html: string): string {
  const template = document.createElement('template')
  template.innerHTML = html

  const walker = document.createTreeWalker(template.content, NodeFilter.SHOW_TEXT)
  const textNodes: Text[] = []
  while (walker.nextNode()) {
    const node = walker.currentNode as Text
    if (!node.parentElement?.closest('a')) textNodes.push(node)
  }

  for (const node of textNodes) {
    const text = node.nodeValue ?? ''
    const matches = [...text.matchAll(URL_PATTERN)]
    if (matches.length === 0) continue

    const fragment = document.createDocumentFragment()
    let last = 0
    for (const match of matches) {
      const start = match.index ?? 0
      const link = document.createElement('a')
      link.href = match[0]
      link.textContent = match[0]
      fragment.append(text.slice(last, start), link)
      last = start + match[0].length
    }
    fragment.append(text.slice(last))
    node.replaceWith(fragment)
  }

  template.content.querySelectorAll<HTMLAnchorElement>('a[href^="http"]').forEach((link) => {
    link.target = '_blank'
    link.rel = 'noopener noreferrer'
  })

  return template.innerHTML
}
